export function bindStorefrontRoutes(routes, components) {
	return routes.map((route) => bindRoute(route, components))
}

function bindRoute(route, components) {
	const next = {}
	for (const [key, value] of Object.entries(route)) {
		if (key === 'catchAll' || key === 'component' || key === 'children') continue
		next[key] = value
	}
	if (typeof route.component === 'string') {
		const resolved = components[route.component]
		if (!resolved) {
			throw new Error(`Storefront route ${route.path || '(child)'} is missing component "${route.component}"`)
		}
		next.component = resolved
	}
	if (route.children) next.children = route.children.map((child) => bindRoute(child, components))
	return next
}
